import axios from 'axios';
import { AxiosError } from 'axios';
import { processAxiosError } from '../../utils/AxiosInterceptors/ErrorInterceptor';
import {
  API_RESULT_CD,
  BAD_REQUEST,
  CommonResult,
  createApiRequestUrl,
  FORBIDDEN,
  INTERNAL_SERVER_ERROR,
  NOT_FOUND,
  OK,
  SERVICE_TEMPORARILY_UNAVAILABLE,
} from '../Common';
import { API_EXCEPTION_MSG } from '../../Common';

const URL = createApiRequestUrl('agencyDetail');

export interface AgencyDetailInfo {
  ordcstmCd: string;
  effectiveDtFrom: string;
  effectiveDtTo: string;
  agencyCd: string;
  billcstmCd?: string;
  companyCfc: string;
  companyCfcLongNm?: string;
  longNm: string;
  shortNm: string;
  channelCd?: string;
  channelCdLongNm?: string;
  shopCd?: string;
  selectedForFilter?: boolean;
}

export interface AgencyDetailApiResponse {
  result: CommonResult;
  agencyDetailDto?: AgencyDetailInfo;
}

export async function agencyDetailApi(agencyCd: string[]): Promise<AgencyDetailApiResponse> {
  try {
    const response = await axios.get<AgencyDetailApiResponse>(`${URL}?agencyCd=${agencyCd.join(',')}`);
    const status = response.status;

    switch (status) {
      case OK.status:
        return response.data;
      case INTERNAL_SERVER_ERROR.status:
        throw new Error(INTERNAL_SERVER_ERROR.message);
      case BAD_REQUEST.status:
        throw new Error(BAD_REQUEST.message);
      case NOT_FOUND.status:
        throw new Error(NOT_FOUND.message);
      case FORBIDDEN.status:
        throw new Error(FORBIDDEN.message);
      default:
        throw new Error('APIとの接続に失敗しました');
    }
  } catch (error) {
    return {
      result: {
        jobDateTime: '',
        resultCd: API_RESULT_CD.ERROR,
        resultMessageDtoList: [
          {
            resultMessageCd: '9999',
            resultMessage: `${API_EXCEPTION_MSG}  エラー内容:[${error}]`,
          },
        ],
      },
    };
  }
}

export interface AgencyDetailByCustomerIdRequest {
  customerId: number;
}

export interface AgencyDetailByCustomerIdResponse {
  ordcstmCd: string;
  longNm: string;
  shortNm: string;
  telNo: string;
  supportContactUrl: string;
  result: CommonResult;
}

/**
 * 顧客所属店舗情報取得API
 * @param customerId 顧客ID
 */
export async function getAgencyDetailByCustomerIdApi(request: AgencyDetailByCustomerIdRequest): Promise<AgencyDetailByCustomerIdResponse> {
  try {
    const response = await axios.get<AgencyDetailByCustomerIdResponse>(`${URL}/${request.customerId}`);
    const status = response.status;
    const data = response.data;
    switch (status) {
      case OK.status:
        return data;
      case SERVICE_TEMPORARILY_UNAVAILABLE.status:
        return data;
      default:
        throw new Error();
    }
  } catch (error) {
    const errorResponse = processAxiosError(error as AxiosError);
    return {
      ...errorResponse.data,
      ordcstmCd: '',
      longNm: '',
      shortNm: '',
      telNo: '',
      supportContactUrl: '',
    };
  }
}
